export default "__VITE_ASSET__BRPvE6_I__"